import { appSettings } from "@/appSettings";
import BaseStoreBuilder from "@/store/base/BaseStoreBuilder";

const organisations = new BaseStoreBuilder({
  baseURL: appSettings.BaseUrl,
  entityName: "organisation"
})
  .getEntitiesList()
  .build();

export default organisations;